module.exports = require("./file");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file2/index.js
 ** module id = 5
 ** module chunks = 0
 **/